import { getLocale, getEnv } from '@shopee/global-env';
import { isFeatureEnabled as isStaticFeatureEnabled } from '@shopee-user/static-feature-toggle';
import { Feature as StaticFeature } from '@shopee-user/static-feature-toggle';
import type { IABTestClient } from './types';
import {
  BusinessTargetConfig,
  BusinessTarget,
  Env,
  Locale,
} from '@shopee-user/global';

const loadClient = () =>
  import(/* webpackChunkName: "AbTestClient" */ './AbTestClient');

const { getABTestConfig } = BusinessTargetConfig[
  __BUSINESS_TARGET__ as BusinessTarget
];

let loadABTestClientPromise: Promise<IABTestClient | null> | null = null;

const initABTest = async () => {
  if (loadABTestClientPromise) return loadABTestClientPromise;

  const config = getABTestConfig(getEnv() as Env, getLocale() as Locale);

  // abtest sdk can only append experiment context to the v4 request
  const isTrackingSdkV4Enabled = isStaticFeatureEnabled(
    StaticFeature.TobWebTrackingSdkV4Integration,
    false
  );

  loadABTestClientPromise = new Promise(resolve => {
    if (!config || !isTrackingSdkV4Enabled) {
      if (!isTrackingSdkV4Enabled) {
        console.warn(
          'abtest is not working because tracking sdk v4 is not enabled yet'
        );
      }
      resolve(null);
      return;
    }

    loadClient()
      .then(module => {
        const ABTestClient = module.default;
        const client = new ABTestClient(config);
        resolve(client);
      })
      .catch(() => {
        resolve(null);
      });
  });
  return await getABTestClient();
};

const getABTestClient = async () => {
  return loadABTestClientPromise ? await loadABTestClientPromise : null;
};

export { getABTestClient, initABTest };
